import './ClOfferSnippetEmpty.css';

import React from 'react';

import classname from '@search/classname/src';
import { Typography, Button } from '@vtblife/uikit';

const cn = classname.bind(null, 'ClOfferSnippetEmpty');

export function ClOfferSnippetEmpty({
    children = <>Объявление снято с&nbsp;публикации</>,
    description = <>Перейдите к&nbsp;фильтрам или посмотрите похожие объявления.</>,
    // onClick,
    // size = 's'
}: {
    description?: React.ReactNode;
    children?: React.ReactNode;
} & Pick<React.ComponentProps<typeof Button>, 'onClick' | 'size'>) {
    return (<div className={cn()}>
        <div className={cn('inner')}>
            <div className={cn('head')}>{children}</div>
            <Typography variant='primary'>{description}</Typography>
            {/*<div className={cn('button')}>*/}
            {/*    <Button onClick={onClick} fullWidth dataTest='search-click' size={size}>Перейти к фильтрам</Button>*/}
            {/*</div>*/}
        </div>
    </div>);
}
